import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { Processor } from '../../models';
import { DialogService, JobsService, ProcessorService } from '../../services';

@Component({
  selector: 'prism-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit, OnDestroy {

  jobs$: Observable<any[]> = this.jobService.jobs$;
  processor$ = this.processorService.processor$;
  jobsLoading$: Observable<boolean> = this.jobsService.areJobsLoading$;
  fetchJobsSub: Subscription;
  invoicesQueueCountSub: Subscription;

  constructor(private jobService: JobsService,
              private processorService: ProcessorService,
              private dialogService: DialogService,
              private jobsService: JobsService
  ) {
  }

  ngOnInit() {
    const killProcessorCheckSub$ = new Subject();

    this.processorService.processor$
      .pipe(
        takeUntil(killProcessorCheckSub$)
      )
      .subscribe(
        (processor: Processor) => {

          if (!processor) {
            this.processorService.getProcessor()
              .toPromise()
              .then()
              .catch(e => {
                console.error('Could not fetch Processor:', e);
              });
          }
          killProcessorCheckSub$.next(null);
        },
        error => {
          console.error('Could check for Processor:', error);
        },
        () => {
        }
      );

    this.jobsService.setSelectedJob(null);
    this.fetchJobs({pageIndex: 0, pageSize: 10});
  }

  fetchJobs({pageIndex, pageSize}) {
    this.fetchJobsSub = this.jobService.fetchJobsFromDatabase({pageIndex, pageSize})
      .pipe(
        first(d => !!d)
      )
      .subscribe();
  }

  ngOnDestroy() {
    if (!!this.invoicesQueueCountSub) {
      this.invoicesQueueCountSub.unsubscribe();
    }
    if (!!this.fetchJobsSub) {
      this.fetchJobsSub.unsubscribe();
    }
  }
}
